// Cached list of organizations the signed-in user is a `member` of, per
// BA's `/auth/v1/organization/list`. Source of truth for the top-nav org
// picker — earlier the chip derived orgs from the joined-events list,
// which missed orgs without any events the user was a guest on.

import { create } from "zustand"
import { listClients, type ClientOrg } from "./admin"

type State = {
  orgs: ClientOrg[]
  loading: boolean
  loaded: boolean
  error: string | null
  load: () => Promise<void>
  reload: () => Promise<void>
}

export const useUserOrgs = create<State>((set, get) => ({
  orgs: [],
  loading: false,
  loaded: false,
  error: null,
  async load() {
    if (get().loaded || get().loading) return
    set({ loading: true, error: null })
    try {
      const orgs = await listClients()
      set({ orgs, loading: false, loaded: true, error: null })
    } catch (err) {
      set({
        loading: false,
        loaded: true,
        error: err instanceof Error ? err.message : "Failed to load organizations",
      })
    }
  },
  async reload() {
    set({ loading: true, error: null })
    try {
      const orgs = await listClients()
      set({ orgs, loading: false, loaded: true, error: null })
    } catch (err) {
      set({
        loading: false,
        loaded: true,
        error: err instanceof Error ? err.message : "Failed to load organizations",
      })
    }
  },
}))

export function resetUserOrgsStore() {
  useUserOrgs.setState({
    orgs: [],
    loading: false,
    loaded: false,
    error: null,
  })
}
